// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"210":"aa82fe3e","483":"2fb98766","511":"21efed8c"}[chunkId] + ".chunk.css";
};